/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Tut_Issue_S5Inputs */

const en_mk_tut_issue_s5 = /** @type {(inputs: Mk_Tut_Issue_S5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Switch layout with the **List · Board · Table** picker in the toolbar. Your choice is remembered per page.`)
};

const id_mk_tut_issue_s5 = /** @type {(inputs: Mk_Tut_Issue_S5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ganti tampilan lewat pemilih **Daftar · Papan · Tabel** di toolbar. Pilihan Anda diingat per halaman.`)
};

/**
* | output |
* | --- |
* | "Switch layout with the **List · Board · Table** picker in the toolbar. Your choice is remembered per page." |
*
* @param {Mk_Tut_Issue_S5Inputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_tut_issue_s5 = /** @type {((inputs?: Mk_Tut_Issue_S5Inputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Tut_Issue_S5Inputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_tut_issue_s5(inputs)
	return en_mk_tut_issue_s5(inputs)
});